import { render, staticRenderFns } from "./TabQuery.vue?vue&type=template&id=ae0e071a&scoped=true&"
import script from "./TabQuery.vue?vue&type=script&lang=ts&"
export * from "./TabQuery.vue?vue&type=script&lang=ts&"
import style0 from "./TabQuery.vue?vue&type=style&index=0&id=ae0e071a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0e071a",
  null
  
)

export default component.exports